import FinancialDetailsModule from '@/modules/financial-details/FinancialDetailsModule';

export default FinancialDetailsModule;
